import { useEffect } from 'react';

import useShowPaymentResult from '../../../../hooks/useShowPaymentResult';
import { useSigningContext } from '../../../../signingContext/signingContext';
import useFocusContext from '../../hooks/useFocusContext';

export default (useExternalAddReceiver: boolean, showAddReceiver?: boolean, redirectLinkAvtalegiro?: string) => {
    const {
        toggleSwitchState,
        active: { value: active },
    } = useFocusContext();

    const { showPaymentRetry, signingStatus } = useSigningContext();
    const showPaymentResult = useShowPaymentResult();
    useEffect(() => {
        toggleSwitchState.set('enabled');
        if (showPaymentRetry || showPaymentResult) {
            toggleSwitchState.set('hidden');
        }

        if (redirectLinkAvtalegiro && signingStatus === 'COMPLETED') {
            toggleSwitchState.set('enabled');
        }

        if (useExternalAddReceiver && showAddReceiver && active) {
            toggleSwitchState.set('hidden');
        }

        return () => toggleSwitchState.set('enabled');
    }, [
        toggleSwitchState.set,
        showPaymentRetry,
        showPaymentResult,
        redirectLinkAvtalegiro,
        signingStatus,
        active,
        toggleSwitchState,
        showAddReceiver,
        useExternalAddReceiver,
    ]);
};
